export default "__VITE_ASSET__D1FP0Y6t__"